import React, { PureComponent } from 'react'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import McActions from 'store/redux/mc'
import { Form } from 'reactstrap'
import { FG, Button } from 'components'
import { pageData } from 'decorators'
import { translate } from 'react-i18next'
import AdminTemplate from '../../templates/AdminTemplate'
import './McHome.css'

@connect(
    state => ({
        isLoading: state.global.loading
        // initialValues: {
        //     gameCode: 'HT0MNPE'
        // }
    }),
    {
        requestNewGameTemplate: McActions.requestNewGameTemplate,
        requestGameList: McActions.requestGameList,
        accessGame: McActions.requestGameData
    }
)
@pageData({ title: 'MC Home' })
@translate()
@reduxForm({ form: 'mcHome' })
export class McHome extends PureComponent {
    componentWillReceiveProps(nextProps) {
        if (this.props.isLoading && !nextProps.isLoading) {
            this.buttonPressed = undefined
        }
    }
    onSubmit = ({ gameCode }) => {
        this.buttonPressed = 'access'
        this.props.accessGame({ gameCode })
    }
    handleNewGameClick = () => {
        this.buttonPressed = 'newGame'
        this.props.requestNewGameTemplate()
    }
    handleGameListClick = () => {
        this.buttonPressed = 'gameList'
        this.props.requestGameList()
    }

    render() {
        const { handleSubmit, invalid, submitting, isLoading, t } = this.props
        return (
            <AdminTemplate className="McHome">
                <div className="flex-grow flex col-center">
                    <h1>{t('mc.home.title')}</h1>
                    <Button tag="a" color="primary" loading={isLoading && this.buttonPressed === 'newGame'} onClick={this.handleNewGameClick}>
                        {t('mc.home.newGameBtn')}
                    </Button>
                    <Button tag="a" color="primary" className="mt-5" loading={isLoading && this.buttonPressed === 'gameList'} onClick={this.handleGameListClick}>
                        {t('mc.home.gameListBtn')}
                    </Button>
                    <Form onSubmit={handleSubmit(this.onSubmit)}>
                        <div className="flex row-center">
                            <FG.Text id="gameCode" name="gameCode" label={t('mc.home.gameCodeLabel')} required />
                            <Button type="submit" color="primary" loading={isLoading && this.buttonPressed === 'access'} disabled={invalid || submitting}>
                                {t('mc.home.accessBtn')}
                            </Button>
                        </div>
                    </Form>
                </div>
            </AdminTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/MC/Home/McHome.js